<template>
	<div class="tabs">
		<div class="tab-btns">
			<router-link class="tab-btn" to="/">
				<!-- <img alt="DCP Logo" class="tab-icon" src="@/assets/logo.png"> -->
				<img alt="Settings" class="tab-icon tab-inner-fade" src="@/assets/sprites/house.png">
			</router-link>

			<router-link class="tab-btn" to="/about">
				<img alt="Settings" class="tab-icon tab-inner-fade tab-icon-docs" src="@/assets/sprites/document.png">
			</router-link>

			<router-link class="tab-btn tab-btn-center" to="/guides">
				<span class="tab-btn-character tab-inner-fade">?</span>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HomeBtn'
	}
</script>
